"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGEventHandler = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var model_1 = require("../../../model");
var bindings_1 = require("../../bindings");
var marker_create_binding_1 = require("../../bindings/marker.create.binding");
var draw_state_1 = require("../../draw.state");
var util_draw_svg_1 = require("../../drawable/util.draw.svg");
var svg_event_translation_1 = require("./svg.event.translation");
var svg_move_1 = require("./svg.move");
var MAX_CLICK_MOVEMENT = 15;
var SVGEventHandler = /** @class */ (function () {
    function SVGEventHandler(dc, onStartHOASession) {
        this.onStartHOASession = onStartHOASession;
        this.dc = dc;
    }
    SVGEventHandler.getStructure = function (evt) {
        var output = {
            id: null,
            label: null,
            tag: null,
            draggable: false,
            point: null,
            $event: null
        };
        if (evt.target == null) {
            return output;
        }
        var current = evt.target;
        var count = 0;
        while (current.parentNode != null) {
            var nodeId = current.getAttribute('c-Draw-node-id');
            if (output.id == null && nodeId != null) {
                output.id = nodeId;
                output.tag = current.getAttribute('c-Draw-tag');
            }
            var labelId = current.getAttribute('c-Draw-Label');
            if (labelId != null && output.label == null) {
                output.label = labelId;
                if (current.getAttribute('c-Draw-draggable') === 'true' || current.getAttribute('c-Draw-draggable') === true) {
                    output.draggable = true;
                }
            }
            // Label will be present before the node-id
            if (output.id && (output.label || count > 0)) {
                return output;
            }
            current = current.parentNode;
            count++;
        }
        return output;
    };
    SVGEventHandler.prototype.click = function ($event) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var dc = this.dc;
        var state = dc.state;
        var clickX = state.mouseDownX;
        var clickY = state.mouseDownY;
        if (clickX != null) {
            var diffXY = Math.abs(clickX - $event.clientX) + Math.abs(clickY - $event.clientY);
            if (diffXY > MAX_CLICK_MOVEMENT) {
                return;
            }
        }
        var ctx = SVGEventHandler.getStructure($event);
        var drawableId = ((ctx.label === util_draw_svg_1.IkeDrawLabel.LABEL) && ctx.id) ? ctx.id : undefined;
        var center = svg_event_translation_1.SVGEventTranslation.translateEvent($event);
        var tool = state.tool;
        if (this.dc.state.linkFieldIds.length > 0) {
            (_a = this.onStartHOASession) === null || _a === void 0 ? void 0 : _a.call(this);
            bindings_1.IkeDrawBindings.Measurement.Marker.create(dc, { drawableId: drawableId, center: center, $event: $event });
            return;
        }
        if (ctx.label === util_draw_svg_1.IkeDrawLabel.DELETE) {
            (_b = this.onStartHOASession) === null || _b === void 0 ? void 0 : _b.call(this);
            bindings_1.IkeDrawBindings.Measurement.delete(dc, { drawableId: ctx.id, $event: $event });
            return;
        }
        if (ctx.label === util_draw_svg_1.IkeDrawLabel.ACCEPT) {
            (_c = this.onStartHOASession) === null || _c === void 0 ? void 0 : _c.call(this);
            bindings_1.IkeDrawBindings.Measurement.accept(dc, { drawableId: ctx.id, $event: $event });
            return;
        }
        if (tool === draw_state_1.IkeDrawTool.BASE || tool === draw_state_1.IkeDrawTool.MARKER) {
            // If there is an insight base, move it to the new location and approve it instead of creating a new base marker
            // This way we can inform insight of the new base location even if the user doesn't necessarily have permissions
            // to view the insight markers
            // This should not trigger as we don't support insight base & base offsets made by the back end yet
            if (tool === draw_state_1.IkeDrawTool.BASE && dc.drawState.insightBase) {
                (_d = this.onStartHOASession) === null || _d === void 0 ? void 0 : _d.call(this);
                // Move the drawable and its label to the new location
                dc.drawState.insightBase.Mutator.move(center.x, center.y);
                dc.drawState.insightBase.label.Mutator.move(0, center.y + marker_create_binding_1.LABEL_DELTA.y);
                // If there is a base offset value, then remove it as the user is determining a new base value
                dc.drawState.insightBase.Mutator.offset(0);
                // Approve the insight base as a normal base
                dc.drawState.insightBase.approveInsightFlag();
                // Set the crosshair to false because there is a user generated value on screen
                dc.state.setCrosshair(false);
            }
            else {
                var highlightedId = state.hoverId;
                if (highlightedId && highlightedId !== 'image') {
                    var drawable = dc.drawState.getDrawable(highlightedId);
                    if (drawable && model_1.insightOffsetClassDetections.includes((_f = (_e = drawable.insight) === null || _e === void 0 ? void 0 : _e.detection_class) !== null && _f !== void 0 ? _f : '')) {
                        (_g = this.onStartHOASession) === null || _g === void 0 ? void 0 : _g.call(this);
                        drawable.approveInsightFlag();
                    }
                }
                else {
                    (_h = this.onStartHOASession) === null || _h === void 0 ? void 0 : _h.call(this);
                    bindings_1.IkeDrawBindings.Measurement.Marker.create(dc, { drawableId: drawableId, center: center, $event: $event });
                }
            }
            return;
        }
        if (tool === draw_state_1.IkeDrawTool.LINE) {
            bindings_1.IkeDrawBindings.Measurement.Line.create(dc, { drawableId: drawableId, center: center, $event: $event });
            return;
        }
    };
    SVGEventHandler.prototype.doubleclick = function ($event) {
        var ctx = SVGEventHandler.getStructure($event);
        if (ctx.id == null || ctx.label !== util_draw_svg_1.IkeDrawLabel.LABEL) {
            return;
        }
        var dc = this.dc;
        var state = dc.state;
        state.propertiesShow(ctx.id);
    };
    SVGEventHandler.prototype.mousedown = function (evt) {
        var _this = this;
        var _a, _b;
        var ctx = SVGEventHandler.getStructure(evt);
        var dc = this.dc;
        var state = dc.state;
        state.mouseDownX = evt.clientX;
        state.mouseDownY = evt.clientY;
        if (ctx.id && evt.which === 1 && ctx.tag !== 'image') {
            var object = dc.drawState.getDrawable(ctx.id);
            if (object == null) {
                return;
            }
            if (ctx.label == null) {
                dc.state.setSelected(null, null);
            }
            else {
                // If the base tool is selected, then we don't want to be able to select any other drawable
                if (state.tool !== draw_state_1.IkeDrawTool.BASE) {
                    dc.state.setSelected(ctx.id, ctx.label);
                }
                else {
                    var drawable = dc.drawState.getDrawable(ctx.id);
                    if (model_1.insightOffsetClassDetections.includes((_b = (_a = drawable.insight) === null || _a === void 0 ? void 0 : _a.detection_class) !== null && _b !== void 0 ? _b : '')) {
                        dc.state.setSelected(ctx.id, ctx.label);
                    }
                }
            }
        }
        else {
            dc.state.setSelected(null, null);
        }
        if (ctx.id == null || ctx.draggable !== true) {
            return;
        }
        ctx.$event = evt;
        // Start listening for move events.
        var mover = svg_move_1.SVGMove.create(this.dc, ctx);
        if (mover == null) {
            return;
        }
        state.moveId = ctx.id;
        mover.onMove = function () {
            bindings_1.IkeDrawBindings.Selection.move(dc, {
                label: ctx.label,
                delta: mover.delta,
                $event: null
            });
        };
        mover.onStart = function () {
            var _a;
            (_a = _this.onStartHOASession) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        mover.start();
    };
    SVGEventHandler.prototype.mousemove = function (evt) {
        var _a, _b;
        var ctx = SVGEventHandler.getStructure(evt);
        var state = this.dc.state;
        if (ctx.id == null) {
            state.setHovered(null);
            return;
        }
        // If the base tool is selected, then we don't want to be able to select any other drawable
        if (state.tool === draw_state_1.IkeDrawTool.BASE) {
            var drawable = this.dc.drawState.getDrawable(ctx.id);
            if (!model_1.insightOffsetClassDetections.includes((_b = (_a = drawable.insight) === null || _a === void 0 ? void 0 : _a.detection_class) !== null && _b !== void 0 ? _b : '')) {
                state.setHovered(null);
                return;
            }
        }
        var highlightedId = state.hoverId;
        var currentMove = state.moveId;
        if (currentMove != null) {
            return;
        }
        if (highlightedId == null && ctx.id == null ||
            (highlightedId && ctx.id === highlightedId)) {
            // Not moving and the highlighted ID is the same
            return;
        }
        state.setHovered(ctx.id);
    };
    SVGEventHandler.prototype.mousewheel = function (delta, $event) {
        var dc = this.dc;
        bindings_1.IkeDrawBindings.Image.zoom(dc, {
            delta: delta,
            center: svg_event_translation_1.SVGEventTranslation.translateEvent($event),
            $event: $event
        });
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "click", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "doubleclick", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "mousedown", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "mousemove", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "mousewheel", null);
    return SVGEventHandler;
}());
exports.SVGEventHandler = SVGEventHandler;
//# sourceMappingURL=svg.event.js.map